import React from "react";
import Sider from "antd/es/layout/Sider";
import Menu from "@/components/Layout/menu";
import MineBreadcrumb from "@/components/MineBreadcrumb";
import { useRoutes } from "react-router-dom";
import { Layout } from "antd";
import { ICustomRouterConfig } from "@/routers";
const { Content } = Layout;
type LayoutAuthorityProps = {
  routes: ICustomRouterConfig[];
};

const LayoutAuthority = (props: LayoutAuthorityProps) => {
  const { routes } = props;
  return (
    <Layout className="layout-body" style={{ padding: "12px" }}>
      <Sider className="layout-sider">
        <Menu mode="inline"></Menu>
      </Sider>
      <Content
        className="content"
        style={{
          padding: "16px 0 16px 0",
          marginTop: "0",
        }}
      >
        <MineBreadcrumb router={routes}></MineBreadcrumb>
        {useRoutes(routes)}
      </Content>
    </Layout>
  );
};

export default LayoutAuthority;
